import Big from "big.js";
import {
	calcDemandForecast,
	calcTrial,
	changeBigSegmentPurchaseIntent,
	Constant,
	getScoreSegmentPurchaseIntent,
} from "../server/analytics/v3/output/executive/demand-forecast/aggregate";
import { isDefined } from "../server/lib/common";
import { CorrectionValue } from "../server/models/simulation-value";
import {
	CurrentProductCorrectionValue,
	CurrentProductInitialValue,
} from "../server/types/request/report/simulation/v3/data";
import { SimulationReferenceSourceData } from "../server/types/request/report/simulation/v3/reference-source-data";
import { SegmentPurchaseIntent } from "../server/analytics/v3/output";

/**
 * シミュレーションを行える関数
 * @param {SimulationReferenceSourceData} referenceSourceData シミュレーションで利用するreference source data
 * @param {CurrentProductInitialValue | undefined} currentProductInitialValue 現行品の初期値
 * @param {Constant} constant 定数情報
 * @param {number} defaultRecognition 基準となるrecognitionRate（テスト品のrecognition）
 * @returns
 */
export const makeSimulator = (
	referenceSourceData: SimulationReferenceSourceData,
	currentProductInitialValue: CurrentProductInitialValue | undefined,
	constant: Constant,
	defaultRecognition: number,
) => {
	const getRecognitionData = (recognition: number) => {
		const result = referenceSourceData.recognitionDatas.find(
			(recognitionData) => recognitionData.nAware === recognition,
		);
		if (!isDefined(result)) throw new Error("認知率が見つかりません");
		return result;
	};

	return {
		calc: (
			purchaseIntent: SegmentPurchaseIntent,
			simulationValue: CorrectionValue,
			correctionValue: CurrentProductCorrectionValue,
		) => {
			const purchaseIntentBig = changeBigSegmentPurchaseIntent(purchaseIntent);
			const recognitionRate = getRecognitionData(simulationValue.recognitionRate ?? defaultRecognition);
			const bigTrialResult = calcTrial(
				getScoreSegmentPurchaseIntent(purchaseIntentBig),
				recognitionRate,
				referenceSourceData.user,
				constant,
			);
			const factorValue = correctionValue?.correctionFactor ?? currentProductInitialValue?.correctionFactor;
			const correctionFactor = isDefined(factorValue) ? new Big(factorValue) : undefined;
			return calcDemandForecast(
				bigTrialResult.trial,
				{
					...referenceSourceData.umi,
					gRatio_LocalOther: simulationValue.localRatio ?? referenceSourceData.umi.gRatio_LocalOther,
					gRatio_IBBY: simulationValue.inboundRatio ?? referenceSourceData.umi.gRatio_IBBY,
				},
				simulationValue.purchaseQuantity ?? referenceSourceData.buyPerYear.gRepeat,
				correctionFactor,
			);
		},
	};
};
